import { cva } from 'class-variance-authority';
import { AnchorHTMLAttributes, forwardRef } from 'react';

export const linkStyles = cva(
  'bg-none hover:underline active:underline focus:outline-none focus:ring-none focus:underline font-body cursor-pointer',
  {
    variants: {
      variant: {
        blue: 'active:text-link text-link',
        white: 'active:text-white text-white',
        black: 'active:text-black text-black',
        gray: 'active:text-gray-500 text-gray-500',
      },
    },
    defaultVariants: {
      variant: 'blue',
    },
  }
);

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: 'blue' | 'black' | 'white';
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, className, variant = 'blue', href, ...props }, ref) => {
    return (
      <a
        href={href}
        className={className + ' ' + linkStyles({ variant })}
        ref={ref}
        {...props}
      >
        {children}
      </a>
    );
  }
);
